<template>
  <Card class="relative">
    <CardBody>
      <CardTitle title="Valuations" />
      <AgreementValuations
        :agreement-data="agreementData"
        @on-submit="$emit('valuation-submitted', $event)"
      />
    </CardBody>
  </Card>
</template>

<script setup lang="ts">
// components
import Card from '@/components/card/Card.vue'
import CardBody from '@/components/card/CardBody.vue'
import CardTitle from '@/components/card/CardTitle.vue'
import AgreementValuations from '@/components/unique/agreement/AgreementValuations.vue'
// types
import type { Agreement } from '@/types/domain/agreement'

interface Props {
  agreementData: Agreement
}

defineProps<Props>()

defineEmits<{
  'valuation-submitted': [data: Record<string, unknown>]
}>()
</script>
